module.exports = (localeText, phase) => {
  return {
    enter_credentials: localeText(
      'rw_msg_migration_guidance_text_enter_credientials',
      'Please enter your previous account information to proceed with the migration to the new system.'
    ),
    security_question: localeText(
      'rw_msg_migration_guidance_text_answer_security_questions',
      'Please answer the following security question associated with your previous account.'
    ),
    review_confirm_info: localeText(
      'rw_msg_migration_guidance_text_review_details',
      'Please review and confirm the information below about your previous system account.'
    ),
    transition_complete: ''
  }[phase];
};
